import { CheckIcon, PencilSimpleIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

interface TabActionsProps {
  isEditing: boolean
  isSaving: boolean
  onCancel: VoidFunction
  onEdit: VoidFunction
  onSave: VoidFunction
}

export const TabActions = ({ isEditing, isSaving, onCancel, onEdit, onSave }: TabActionsProps) => {
  const { t } = useTranslation(['common'])

  if (!isEditing) {
    return (
      <Button size="small" onClick={onEdit}>
        {t('common:actions.edit')}
        <Icon icon={PencilSimpleIcon} />
      </Button>
    )
  }

  return (
    <>
      <Button disabled={isSaving} size="small" use="secondary" onClick={onCancel}>
        {t('common:actions.cancel')}
      </Button>
      <Button size="small" loading={isSaving} onClick={onSave}>
        {t('common:actions.save')}
        <Icon icon={CheckIcon} />
      </Button>
    </>
  )
}
